<template>
  <v-container
    id="wizard"
    tag="section"
  >
    <base-material-wizard
      v-model="tab"
      :available-steps="availableSteps"
      :items="tabs"
      :loading="loading"
      class="mx-auto"
      color="green"
      @click:next="next"
      @click:prev="tab--"
      @tab:change="save"
    >
      <v-tab-item>
        <form
          action=""
          data-vv-scope="openEnrollment"
        >
          <div class="text-center display-1 font-weight-light mb-6">
            Open Enrollment Details
          </div>
          <open-enrollment-tab
            :disabled="disabled"
            :edited-item="openEnrollmentRecord"
            :form-errors="formErrors"
            @change="onOpenEnrollmentChange"
          />
        </form>
      </v-tab-item>
      <v-tab-item
        v-if="isRenewal"
      >
        <form
          action=""
          data-vv-scope="renewal"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <renewal-tab
            v-if="hasOE"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="summaryChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="payGroup"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <note
            :open-enrollment="openEnrollmentRecord"
            :section="sections.payGroup"
          />
          <pay-group-tab
            v-if="hasOE"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="summaryChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="jobClass"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <note
            :open-enrollment="openEnrollmentRecord"
            :section="sections.jobClass"
          />
          <job-class-tab
            v-if="hasOE"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="jobClassChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="location"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <note
            :open-enrollment="openEnrollmentRecord"
            :section="sections.location"
          />
          <location-tab
            v-if="hasOE"
            :key="locationKey"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="locationChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="eligibilityGroup"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <note
            :open-enrollment="openEnrollmentRecord"
            :section="sections.eligibilityGroup"
          />
          <eligibility-group-tab
            v-if="hasOE"
            :key="eligibilityGroupKey"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="eligibilityGroupChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="eligibility"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <note
            :open-enrollment="openEnrollmentRecord"
            :section="sections.eligibility"
          />
          <eligibility-tab
            v-if="hasOE"
            :key="eligibilityKey"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="eligibilityChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="cobra"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <note
            :open-enrollment="openEnrollmentRecord"
            :section="sections.cobra"
          />
          <cobra-tab
            v-if="hasOE"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="summaryChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="deduction"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <note
            :open-enrollment="openEnrollmentRecord"
            :section="sections.deduction"
          />
          <deduction-tab
            v-if="hasOE"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="summaryChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="enroller"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <note
            :open-enrollment="openEnrollmentRecord"
            :section="sections.enrollers"
          />
          <enroller-tab
            v-if="hasOE"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="summaryChanged"
          />
        </form>
      </v-tab-item>
      <v-tab-item>
        <form
          action=""
          data-vv-scope="template"
        >
          <v-progress-linear
            v-if="!hasOE"
            indeterminate
            color="green"
          />
          <template-tab
            v-if="hasOE"
            :key="templatesKey"
            :disabled="disabled"
            :open-enrollment="openEnrollmentRecord"
            :form-errors="formErrors"
            @item:changed="summaryChanged"
          />
        </form>
      </v-tab-item>
      <template v-slot:buttons>
        <v-btn
          color="green darken-1"
          @click="finished"
        >
          Close
        </v-btn>
      </template>
    </base-material-wizard>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { extractFormErrors, getErrorTitle } from '@/services/ErrorHandlers'
  import { mapGetters } from 'vuex'
  import { isProjectManager } from '@/services/roleValidator'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'OpenEnrollmentWizard',

    components: {
      Note: () => import('./Note'),
      OpenEnrollmentTab: () => import('./OpenEnrollmentTab'),
      RenewalTab: () => import('./RenewalTab'),
      PayGroupTab: () => import('./PayGroupTab'),
      JobClassTab: () => import('./JobClassTab'),
      LocationTab: () => import('./LocationTab'),
      EligibilityGroupTab: () => import('./EligibilityGroupTab'),
      EligibilityTab: () => import('./EligibilityTab'),
      CobraTab: () => import('./CobraTab'),
      DeductionTab: () => import('./DeductionTab'),
      EnrollerTab: () => import('./EnrollerTab'),
      TemplateTab: () => import('./TemplateTab'),
    },

    props: {
      editedItem: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      tab: 0,

      openEnrollmentRecord: null,

      loading: false,
      errorMessage: null,
      displayError: false,

      openEnrollmentDirty: false,
      locationKey: 0,
      eligibilityGroupKey: 0,
      eligibilityKey: 0,
      templatesKey: 0,

      formErrors: {},

      openEnrollmentResource: new TroodyApi('openEnrollment/'),
    }),

    computed: {
      ...mapGetters('oidcStore', ['oidcUser']),

      sections () {
        return Approvals.sections
      },

      disabled () {
        return isProjectManager(this.oidcUser) === false
      },

      tabs () {
        // Renewal introduces a step between open enrollment and paygroup
        if (this.isRenewal) {
          return [
            this.tab === 0 ? 'Open Enrollment' : 'OE',
            this.tab === 1 ? 'Renewal' : 'R',
            this.tab === 2 ? 'Pay Group' : 'PG',
            this.tab === 3 ? 'Job Class' : 'JC',
            this.tab === 4 ? 'Location' : 'L',
            this.tab === 5 ? 'Eligibility Group' : 'EG',
            this.tab === 6 ? 'Eligibility' : 'El',
            this.tab === 7 ? 'COBRA' : 'C',
            this.tab === 8 ? 'Deduction' : 'D',
            this.tab === 9 ? 'Enroller' : 'En',
            this.tab === 10 ? 'Template' : 'T',
          ]
        } else {
          return [
            this.tab === 0 ? 'Open Enrollment' : 'OE',
            this.tab === 1 ? 'Pay Group' : 'PG',
            this.tab === 2 ? 'Job Class' : 'JC',
            this.tab === 3 ? 'Location' : 'L',
            this.tab === 4 ? 'Eligibility Group' : 'EG',
            this.tab === 5 ? 'Eligibility' : 'El',
            this.tab === 6 ? 'COBRA' : 'C',
            this.tab === 7 ? 'Deduction' : 'D',
            this.tab === 8 ? 'Enroller' : 'En',
            this.tab === 9 ? 'Template' : 'T',
          ]
        }
      },

      scope () {
        // Renewal introduces a step between open enrollment and paygroup
        if (this.isRenewal) {
          if (this.tab === 0) return 'openEnrollment'
          else if (this.tab === 1) return 'renewal'
          else if (this.tab === 2) return 'payGroup'
          else if (this.tab === 3) return 'jobClass'
          else if (this.tab === 4) return 'location'
          else if (this.tab === 5) return 'eligibilityGroup'
          else if (this.tab === 6) return 'eligibility'
          else if (this.tab === 7) return 'cobra'
          else if (this.tab === 8) return 'deduction'
          else if (this.tab === 9) return 'enroller'
          return 'template'
        } else {
          if (this.tab === 0) return 'openEnrollment'
          else if (this.tab === 1) return 'payGroup'
          else if (this.tab === 2) return 'jobClass'
          else if (this.tab === 3) return 'location'
          else if (this.tab === 4) return 'eligibilityGroup'
          else if (this.tab === 5) return 'eligibility'
          else if (this.tab === 6) return 'cobra'
          else if (this.tab === 7) return 'deduction'
          else if (this.tab === 8) return 'enroller'
          return 'template'
        }
      },

      availableSteps () {
        const steps = [0]

        if (this.openEnrollmentRecord && this.openEnrollmentRecord.brokerGroupYear && this.openEnrollmentRecord.brokerGroupId) {
          steps.push(1)
          steps.push(2)
          steps.push(3)
          steps.push(4)
          steps.push(5)
          steps.push(6)
          steps.push(7)
          steps.push(8)
          steps.push(9)

          // If this is a renewal, it introduces a new step
          if (this.isRenewal) {
            steps.push(10)
          }
        }

        return steps
      },

      hasOE () {
        return (this.openEnrollmentRecord && this.openEnrollmentRecord.id)
      },

      isRenewal () {
        return (this.hasOE && this.openEnrollmentRecord.isRenewal)
      },

      dataDirty () {
        return this.openEnrollmentDirty
      },
    },

    watch: {
      editedItem (val) {
        this.initialize()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.openEnrollmentRecord = Object.assign({}, this.editedItem)

        this.openEnrollmentDirty = false

        this.formErrors = {}

        this.tab = 0
      },

      jobClassChanged () {
        // Job Class effects location and eligibility group
        this.locationKey++
        this.eligibilityGroupKey++
        this.summaryChanged()
      },

      locationChanged () {
        // Location effect eligibility group
        this.eligibilityGroupKey++
        this.summaryChanged()
      },

      eligibilityGroupChanged () {
        // eligibility group effects eligibility and templates
        this.eligibilityKey++
        this.templatesKey++
        this.summaryChanged()
      },

      eligibilityChanged () {
        // eligibility group effects templates
        this.eligibilityKey++
        this.templatesKey++
        this.summaryChanged()
      },

      summaryChanged () {
        this.$emit('summary:changed', this.openEnrollmentRecord)
      },

      handleAction (action, data) {
        if (action === 'edit') {
          // When editing, we are assuming a role id is now selected associated with the data being edited
          this.roleIdSelected = data.roleId
        }
      },

      finished () {
        this.save()
          .then(() => {
            this.formErrors = {}
            this.$emit('wizard:finished')
          })
      },

      next () {
        this.loading = true
        this.save()
          .then(() => {
            this.loading = false
            if (this.tab === this.tabs.length - 1) {
              this.finished()
            } else {
              this.tab++
            }
          })
      },

      handleError (error) {
        this.loading = false
        this.formErrors = extractFormErrors(error)
        if (this.formErrors) {
          this.showError(getErrorTitle(error), 'Failed to save!')
        } else {
          this.formErrors = {}
          this.showError(error, 'Failed to save!')
        }
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },

      saveOpenEnrollment () {
        const promise = new Promise((resolve, reject) => {
          console.log(this.openEnrollmentRecord)
          this.openEnrollmentResource.save(this.openEnrollmentRecord)
            .then((data) => {
              this.openEnrollmentRecord = data
              this.openEnrollmentDirty = false
              this.save() // Save anything left for the other steps
              this.$emit('openenrollment:saved', data)
              resolve(data)
            })
            .catch((error) => {
              this.tab = 0
              reject(error)
            })
        })

        return promise
      },

      save () {
        const promise = new Promise((resolve, reject) => {
          if (this.dataDirty && this.disabled === false) {
            if (this.openEnrollmentDirty) {
              this.saveOpenEnrollment()
                .then((data) => {
                  resolve(data)
                })
                .catch((error) => {
                  this.handleError(error)
                  reject(error)
                })
            }
          } else {
            resolve({ dataDirty: false })
          }
        })

        return promise
      },

      validateForm (scope) {
        return this.$validator.validateAll(scope)
      },

      onOpenEnrollmentChange (data) {
        this.openEnrollmentRecord = data
        this.openEnrollmentDirty = true
        this.summaryChanged()
      },
    },
  }
</script>

<style lang="sass">
  .v-tab
    min-width: 40px !important
</style>
